var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPreferences(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#A5A8AC",
    fillRule: "evenodd",
    d: "M28.181 21.072c.041-.343.069-.7.069-1.072 0-.371-.027-.729-.082-1.072l2.323-1.815a.568.568 0 0 0 .138-.702l-2.2-3.808a.56.56 0 0 0-.674-.248l-2.736 1.1a8.056 8.056 0 0 0-1.856-1.072l-.413-2.915A.549.549 0 0 0 22.2 9h-4.4a.535.535 0 0 0-.536.468l-.413 2.915a8.271 8.271 0 0 0-1.856 1.072l-2.736-1.1a.544.544 0 0 0-.674.248l-2.2 3.808a.533.533 0 0 0 .138.702l2.323 1.815A6.911 6.911 0 0 0 11.75 20c0 .357.028.729.083 1.072l-2.324 1.815a.568.568 0 0 0-.138.702l2.2 3.809c.138.247.427.33.674.247l2.736-1.1c.578.44 1.183.797 1.857 1.072l.412 2.915a.56.56 0 0 0 .55.468h4.4a.525.525 0 0 0 .536-.468l.413-2.915a8.271 8.271 0 0 0 1.856-1.072l2.736 1.1c.248.096.537 0 .674-.247l2.2-3.81a.533.533 0 0 0-.137-.7l-2.297-1.816zM20 24.125A4.137 4.137 0 0 1 15.875 20 4.137 4.137 0 0 1 20 15.875 4.137 4.137 0 0 1 24.125 20 4.137 4.137 0 0 1 20 24.125z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreferences);
export default __webpack_public_path__ + "static/media/preferences.d1d6cc2f9c592c452b2f58da32ff15d5.svg";
export { ForwardRef as ReactComponent };